module.exports = __webpack_public_path__ + "a76cefccab931442617fffb6c0792785.png";